import {
  getShouldLaunchUndocked,
  getIsMobileSummaryPage
} from './app'
import { THEMES, TABS, LAYOUT_TYPES } from '~/core/constants'
import themes from '~/core/theme'
import { shouldHideUpcoming } from './settings'
import { getIsMeetingLaunched, getIsSessionClosed } from './active-session'

const getLayoutType = state => getState(state).layoutType

export const getState = state => state.ui

export const getMeetingsTab = state => {
  if (shouldHideUpcoming(state)) {
    return TABS.RECENT
  }

  return getState(state).meetingsTab
}

export const getTheme = state => getState(state).theme
export const getSystemTheme = state => getState(state).systemTheme

export const getAppliedTheme = state => {
  const theme = getTheme(state)
  const systemTheme = getSystemTheme(state)

  switch (theme) {
    case THEMES.LIGHT:
      return themes.light
    case THEMES.DARK:
      return themes.dark
    case THEMES.SYSTEM_DEFAULT:
      return themes[systemTheme]
    default:
      return themes.light
  }
}

export const getIsNarrowLayout = state => getLayoutType(state) === LAYOUT_TYPES.NARROW || getIsMobileSummaryPage(state)

export const getDialog = state => getState(state).dialog

export const getDialogProps = state => getState(state).dialogProps

export const getIsFullScreen = state => getState(state).isFullScreen

export const getIsJoinButtonDisabled = state => getState(state).joinButtonDisabled

export const getRoomInputHasError = state => getState(state).roomInputHasError

export const getViewedSessionId = state => getState(state).viewedSessionId

export const getVisibleScreens = state => getState(state).visibleScreens

export const getShowUpcomingPanel = state => getState(state).showUpcomingPanel

export const getShowActiveSession = state => !getIsSessionClosed(state) && !getShouldLaunchUndocked(state)
export const getShowMainPanel = state => !getShowActiveSession(state) && !getIsNarrowLayout(state)
export const getShowSidePanel = state => !getIsFullScreen(state) && getShowUpcomingPanel(state)
export const getWindowSize = state => getState(state).windowSize
export const getShowTimelineTab = state => getIsNarrowLayout(state) || !getShouldLaunchUndocked(state)
export const getShowSplashScreen = state =>
  !getShouldLaunchUndocked(state) &&
  getShowMainPanel(state) &&
  !getViewedSessionId(state)

export const getShowMeetingInProgressBanner = state => getShouldLaunchUndocked(state) && getIsMeetingLaunched(state)
